export const DEFAULT_SIZE = 40;
export const DEFAULT_COLOR = '#333';
//# sourceMappingURL=types.js.map